/* unplugin-vue-components disabled */import script from "./Course.vue?vue&type=script&setup=true&lang=js"
export * from "./Course.vue?vue&type=script&setup=true&lang=js"

import "./Course.vue?vue&type=style&index=0&id=37a9dbf9&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-哈工程-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a9dbf9"]])

export default __exports__